import { API } from '../constants';
import { ApiService } from './api.service';

export const FeedbackRejectReasonService = {
  getFeedbackRejectReasons() {
    return ApiService.get(API.GET.FEEDBACK_REASON.GET);
  },
};
